import { getters } from '/@/modules/core/app/helpers/store';
import { Estate } from '@/modules/estate/models/Estate';
import { HasCurrentEstateMixin } from '@/modules/core/app/mixins/HasCurrentEstateMixin';

export const HasPermissionMixin = {
  mixins: [HasCurrentEstateMixin],
  computed: {
    /** @returns {AuthUserPermission} */
    permission() {
      return getters.auth.getPermission(this.estate ?? this.currentEstate);
    }
  },
  props: {
    estate: {
      // type: Object as PropType<Estate>
      type: Object,
      required: false
    }
  }
};
